import { KeyboardEvent, SyntheticEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PrimaryButton } from "../components/buttons";
import { PrimaryInput } from "../components/inputs";
import { redLogo } from "../../assets/svg";

const TENANT_BASE_URL = process.env.REACT_APP_TENANT_BASE_URL;

const getCodeParam = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code") || "";
  return code.split("?")[0];
};

const ResetTenantPassword = () => {
  const [payload, setPayload] = useState({
    confirmPassword: "",
    password: "",
    code: getCodeParam(),
  });

  const [required, setRequired] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const _handleReset = (e?: SyntheticEvent<HTMLFormElement>) => {
    setLoading(true);
    if (!required) return;
    e?.preventDefault();

    fetch(`${TENANT_BASE_URL}/password/reset/`, {
      method: "POST",

      body: JSON.stringify(payload),

      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then(() => {
        toast.success("password changed successfully");
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Invalid Code");
        setLoading(false);
        throw error;
      });
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      _handleReset();
    }
  };

  const onGetInputValue = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    const name = event.currentTarget.name;

    setPayload({ ...payload, [name]: value });
  };

  useEffect(() => {
    const { confirmPassword, password } = payload;
    setRequired(
      confirmPassword.length > 0 &&
        password.length > 0 &&
        confirmPassword === password
    );
  }, [payload]);

  return (
    <div className="h-screen bg-grey-2 sm:py-12 lg:py-32 flex items-center justify-center">
      <form
        className="flex flex-col items-stretch justify-center bg-white rounded-xl h-full w-full sm:h-auto p-12 sm:w-8/12 lg:w-7/12 xl:w-4/12"
        onSubmit={_handleReset}
      >
        <img src={redLogo} alt="logo" className="h-10 w-10 mx-auto" />
        <h1 className="text-neutral-800 bold text-center text-2xl mt-2">
          Reset your password
        </h1>

        <PrimaryInput
          onChange={onGetInputValue}
          onKeyDown={handleKeyDown}
          placeholder="Enter new password"
          required
          name="password"
          label="New Password"
          type="password"
        />
        <PrimaryInput
          onChange={onGetInputValue}
          onKeyDown={handleKeyDown}
          placeholder="Confirm new password"
          required
          name="confirmPassword"
          label="Confirm New Password"
          type="password"
        />

        <PrimaryButton
          loading={loading}
          disabled={!required || loading}
          text="Reset Password"
          type="submit"
          classNames="mt-10 medium"
        />
      </form>
    </div>
  );
};

export default ResetTenantPassword;
